import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const Message: FunctionalComponent<IIconProps> = ({ width = '16', height = '16', fill = '#666' }) => {
  return (
    /*@ts-ignore*/
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.41749 12.8128C8.21969 11.8551 6.73177 11.3335 5.19823 11.3335H3.33345C2.96526 11.3335 2.66678 11.035 2.66678 10.6668V3.33347C2.66678 2.96528 2.96526 2.6668 3.33345 2.6668H12.6668C13.035 2.6668 13.3334 2.96528 13.3334 3.33347V10.6668C13.3334 11.035 13.035 11.3335 12.6668 11.3335H10.0023V13.2803L9.41749 12.8128ZM12.6667 12.6667C13.7713 12.6667 14.6667 11.7713 14.6667 10.6667V3.3334C14.6667 2.22884 13.7713 1.3334 12.6667 1.3334H3.33342C2.22885 1.3334 1.33342 2.22884 1.33342 3.3334V10.6667C1.33342 11.7713 2.22885 12.6667 3.33342 12.6667H5.1982C6.42912 12.6667 7.62343 13.0855 8.58487 13.8541L9.71113 14.7545C10.1425 15.0994 10.7718 15.0293 11.1166 14.5979C11.2584 14.4207 11.3356 14.2004 11.3356 13.9735V12.6667H12.6667Z"
        fill={fill}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.66667 8C4.29848 8 4 8.29848 4 8.66667C4 9.03486 4.29848 9.33333 4.66667 9.33333H7.33333C7.70152 9.33333 8 9.03486 8 8.66667C8 8.29848 7.70152 8 7.33333 8H4.66667Z"
        fill={fill}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.66667 4.66666C4.29848 4.66666 4 4.96513 4 5.33332C4 5.70151 4.29848 5.99999 4.66667 5.99999H11.3333C11.7015 5.99999 12 5.70151 12 5.33332C12 4.96513 11.7015 4.66666 11.3333 4.66666H4.66667Z"
        fill={fill}
      />
    </svg>
  );
};

export default Message;
